import {call, put, select, takeEvery} from 'redux-saga/effects';
import { push } from 'react-router-redux';
import {onAppLoad, onAppLoadFail, onAppLoadSuccess, onAppSubmit, onAppSubmitFail, onAppSubmitSuccess} from "./actions";
import {appLoadInfo, appSave} from "./api";

function* appSubmit() {
    try {
        const { details, splash, main} = yield select(state => state.app);
        const filter = {
            details,
            splash,
            main
        }

        const response = yield call(appSave, filter)

        yield put(onAppSubmitSuccess(response))
        yield put(push('/chain/app?step=done'))
    } catch (e) {
        yield put(onAppSubmitFail(e))
    }
}

function* appLoad(action) {
    try {
        const response = yield call(appLoadInfo)
        yield put(onAppLoadSuccess(response))
    } catch (e) {
        yield put(onAppLoadFail(e))
    }
}

function* categoriesSaga() {
    yield takeEvery(onAppSubmit().type, appSubmit);
    yield takeEvery(onAppLoad().type, appLoad);
}

export default categoriesSaga;
